import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/pro-regular-svg-icons";

import docs from "../../../../../../docs/directory.json";

import Badge from "ui/Badge";

import { AnnotatedPlan, Annotation, Node } from "types/explain";

import styles from "./style.module.scss";
import SignificantFields from "features/Explain/ExplainSignificantFields";
import { describeAnnotation, getInsightLink } from "utils/explain";

const Overview = ({
  plan,
  nodeAnnotations,
  node,
}: {
  plan: AnnotatedPlan;
  nodeAnnotations: Annotation[];
  node: Node;
}) => {
  return (
    <>
      <SignificantFields node={node} />
      {nodeAnnotations.length > 0 && (
        <>
          <hr />
          <Insights plan={plan} nodeAnnotations={nodeAnnotations} />
        </>
      )}
    </>
  );
};

const Insights = ({
  plan,
  nodeAnnotations,
}: {
  plan: AnnotatedPlan;
  nodeAnnotations: Annotation[];
}) => {
  const annotations = nodeAnnotations.map((ann) => {
    const insightInfo =
      docs.explainInsights[ann.type as keyof typeof docs.explainInsights];
    let insightLink =
      insightInfo?.path && `https://pganalyze.com${insightInfo.path}`;
    let detail = ann.detail;
    if (ann.type.startsWith("query advisor/")) {
      const description = describeAnnotation(ann, plan.plan);
      detail = `${description.title} (${description.details.join(", ")})`;
      insightLink = getInsightLink(ann.type);
    }
    return {
      type: ann.type,
      detail: detail,
      insightLink: insightLink,
    };
  });
  return (
    <div className={styles.insights}>
      <h4 className="text-lg mb-0 text-[#606060]">
        Insights ({annotations.length})
      </h4>
      <ul className={styles.annotations}>
        {annotations.map((a, i) => {
          return (
            <li key={i}>
              <Badge>{a.type}</Badge> {a.detail}{" "}
              {a.insightLink && (
                <a href={a.insightLink} title="Learn more" target="_blank">
                  <FontAwesomeIcon icon={faExternalLinkAlt} />
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Overview;
